var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"shouye",class:_vm.show ? 'shouye1' : '',on:{"click":_vm.goto}},[_vm._v("首页")]),_vm._v(" "),_c('div',{staticClass:"shouye",class:_vm.show ? 'shouye4' : '',on:{"click":_vm.gotodw}},[_vm._v("\n    应用下载\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea914a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/h5/menu.vue
// module id = null
// module chunks = 